import "./App.css";

import React, { useEffect, useState } from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import { AppRouter } from "./utils/enums/AppRouter";
import { GalleryPage } from "./pages/GalleryPage/GalleryPage";
import { GamePage } from "./pages/GamePage/GamePage";
import { LoginPage } from "./pages/LoginPage/LoginPage";
import { MyGamesPage } from "./pages/MyGamesPage/MyGamesPage";
import { ConstructorPage } from "./pages/ConstructorPage/ConstructorPage";
import { NotFoundPage } from "./pages/NotFoundPage/NotFoundPage";
import { LoginPageAuthorizationRoute } from "./pages/LoginPage/LoginPageAuthorizationRoute";
import { ConstructorPagePrivateRoute } from "./pages/ConstructorPage/ConstructorPagePrivateRoute";
import { AuthorizationStatus } from "./utils/enums/AuthorizationStatus";
import { UsersApi } from "./api-client";
import { ApiFactory } from "./api-client/api-factory";
import { useAppDispatch, useAppSelector } from "./store/store";
import { requireAuthorization } from "./store/actions/appActions";

import loadingImage from "./resources/images/loading.png";
import { PageHeader } from "./components/special/PageHeader/PageHeader";
import { PageFooter } from "./components/special/PageFooter/PageFooter";
import { SecretPage } from "./pages/SecretPage/SecretPage";

const App = () => {
  const dispatch = useAppDispatch();
  const authorizationStatus = useAppSelector(
    (state) => state.user.authorizationStatus
  );

  const [username, setUsername] = useState<string>("");
  const [isInitialDataReceived, setIsInitialDataReceived] =
    useState<boolean>(false);
  const [isAuthorizationStatusReceived, setIsAuthorizationStatusReceived] =
    useState<boolean>(false);

  useEffect(() => {
    if (!isInitialDataReceived) {
      ApiFactory.get(UsersApi)
        .whoamiGet()
        .then((data) => {
          if (data.user?.name) {
            setUsername(data.user?.name);
          }

          dispatch(requireAuthorization(AuthorizationStatus.Auth));
          setIsAuthorizationStatusReceived(true);
        })
        .catch(() => {
          dispatch(requireAuthorization(AuthorizationStatus.NoAuth));
          setIsAuthorizationStatusReceived(true);
        });

      setIsInitialDataReceived(true);
    }
  }, [authorizationStatus, dispatch, isInitialDataReceived]);

  return isAuthorizationStatusReceived ? (
    <div>
      <BrowserRouter>
        <PageHeader username={username} setUsername={setUsername} />
        <Routes>
          <Route path={AppRouter.Game} element={<GamePage />} />
          <Route path={AppRouter.Main} element={<Navigate to={AppRouter.Gallery} replace />} />
          <Route path={AppRouter.Gallery} element={<GalleryPage />} />
          <Route
            path={AppRouter.MyGames}
            element={
              <ConstructorPagePrivateRoute
                authorizationStatus={authorizationStatus}
              >
                <MyGamesPage username={username} />
              </ConstructorPagePrivateRoute>}
          />
          <Route
            path={AppRouter.Constructor}
            element={
              <ConstructorPagePrivateRoute
                authorizationStatus={authorizationStatus}
              >
                <ConstructorPage />
              </ConstructorPagePrivateRoute>
            }
          />
          <Route
            path={AppRouter.Login}
            element={
              <LoginPageAuthorizationRoute
                authorisationStatus={authorizationStatus}
              >
                <LoginPage setUsername={setUsername} />
              </LoginPageAuthorizationRoute>
            }
          />
          <Route path={AppRouter.Secret} element={<SecretPage />} />
          <Route path={AppRouter.NotFoundPage} element={<NotFoundPage />} />
        </Routes>
        <PageFooter />
      </BrowserRouter>
    </div>
  ) : (
    <div className="start_container">
      <div className="loading_block header_2">
        <img className="loading" src={loadingImage} alt="loading..." />
        Загружаем...
      </div>
    </div>
  );
};

export default App;
